import{styled as e}from"@mui/material/styles";const t=e("div")((({theme:e})=>({color:e.palette.orange100.main})));export{t as SubscriptionFormError};
//# sourceMappingURL=styles.js.map
